import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import App from './App';
import store from './store';
import { setLoggedIn } from './actions/player';
import { setShard } from './actions/config';

export default () => {
  const RiotBar = window.RiotBar;

  store.dispatch(setLoggedIn(!!RiotBar.account.getSummonerName()));
  store.dispatch(setShard(RiotBar.account.getRegion()));

  ReactDOM.render(
    <Provider store={store}>
      <App />
    </Provider>,
    document.getElementById('root')
  );
};



// WEBPACK FOOTER //
// ./src/start.js